import { Link } from "react-router-dom";
import { categories, homepageFeaturedCategories } from "@/mocks/categories";

export default function CategoryQuickNav() {
  const featured = homepageFeaturedCategories
    .map((key) => categories.find((category) => category.key === key))
    .filter((category): category is (typeof categories)[number] => Boolean(category));

  return (
    <section className="w-full px-4 pt-12 md:px-6 md:pt-16">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">分类快捷入口</h2>
          <p className="mt-1 text-sm text-foreground-600">按年代、类型、评分与导演多维度快速浏览电影档案</p>
        </div>
        <Link
          to="/category/1990s"
          className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap self-start text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 md:self-auto"
        >
          查看全部分类
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {featured.map((category) => (
          <Link
            key={category.key}
            to={`/category/${category.key}`}
            className="group flex cursor-pointer flex-col items-center gap-3 rounded-lg border border-background-300/70 bg-background-50 px-4 py-5 text-center transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-600">
              <i className={`${category.icon} text-xl`} />
            </span>
            <span className="text-sm font-medium text-foreground-900">{category.name}</span>
            <span className="text-[11px] text-foreground-500">{category.group}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}